import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  isDeleting,
  title,
  description,
}) => {
  const { t } = useTranslation(['promptbar']);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-confirm-dialog-title"
      disableRestoreFocus
    >
      <DialogTitle id="delete-confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting}>
          {t('cancel')}
        </Button>
        <Button color="error" onClick={onConfirm} disabled={isDeleting}>
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default DeleteConfirmDialog;
